<template>
  <div class="box_rank your_rank">
    <h3>{{ $_translations.value.page_leaderboard_section_current_user_title }}</h3>

    <div v-if="!loading" class="prize_user_row">
      <div class="user_img_bg not_clickable">
        <AvatarImage :src="user?.avatar" />
      </div>

      <div class="col_mobile">
        <div class="user_info">
          <p class="name not_clickable">{{ user?.username }}</p>
        </div>

        <div class="rank_and_points">
          <p class="date_txt">
            {{ $_translations.value.page_leaderboard_section_current_user_points }}:
            <b>{{ user?.points ?? '-' }}</b>
          </p>

          <p class="date_txt">
            {{ $_translations.value.page_leaderboard_section_current_user_rank }}:
            <b>{{ user?.rank ?? '-' }}</b>
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import AvatarImage from '@/components/image/AvatarImage.vue';

defineProps({
  user: {
    type: Object,
    default: () => null,
  },
  loading: {
    type: Boolean,
    default: false,
  },
});
</script>
